var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isErpLogin
    ? _c("div", { staticClass: "msg-box-wrap" }, [
        _c(
          "i",
          {
            staticClass: "msg-icon",
            on: {
              mouseenter: function ($event) {
                $event.stopPropagation()
                return _vm.msgHandel.apply(null, arguments)
              },
              mouseleave: _vm.msgLeaveHandel,
            },
          },
          [
            _vm.unreadCount
              ? _c(
                  "div",
                  {
                    staticClass: "msg-badge",
                    class: { "msg-badge-more": _vm.unreadCount > 99 },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.unreadCount > 99 ? "99+" : _vm.unreadCount)
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _c("div", {
          attrs: { id: "msgDom" },
          on: { mouseenter: _vm.msgListHandel, mouseleave: _vm.msgLeaveHandel },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }